import React from "react";
import { Card, CardContent, Stack, Typography, Button, Box } from "@mui/material";
import LogicNodeEditor from "./LogicNodeEditor";

export const createEmptyGroup = (op = "AND") => ({
  type: "GROUP",
  op,
  children: [],
});

// Extract unique slots (name + questionId) from the logic tree
export const extractSlotsFromLogic = (node) => {
  const slotsMap = {};

  const walk = (n) => {
    if (!n) return;
    if (n.type === "SLOT") {
      const key = n.slotId || "";
      if (!key) return;
      if (!slotsMap[key]) {
        slotsMap[key] = {
          slotId: key,
          questionId: n.questionId || null,
        };
      } else if (n.questionId && !slotsMap[key].questionId) {
        slotsMap[key].questionId = n.questionId;
      }
      return;
    }
    if (n.type === "GROUP" && Array.isArray(n.children)) {
      n.children.forEach(walk);
    }
  };

  walk(node);
  return Object.values(slotsMap);
};

const LogicBuilderCard = ({ value, onChange, questions }) => {
  const rootNode = value || createEmptyGroup("AND");

  const handleClear = () => {
    onChange(createEmptyGroup("AND"));
  };

  return (
    <Card variant="outlined" sx={{ width: "100%", mb: 3 }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Typography variant="h6">Quota logic structure</Typography>
          <Button size="small" variant="text" onClick={handleClear}>
            Clear
          </Button>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Define the logic pattern using placeholders. For example:
          (Gender AND Age) OR (Birth gender AND Age). Each placeholder is linked
          to a question, and the quota table below will provide the answer options.
        </Typography>

        <Box sx={{ mt: 1 }}>
          <LogicNodeEditor
            node={rootNode}
            onChange={onChange}
            questions={questions}
            isRoot
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default LogicBuilderCard;
